export const CATEGORIES = {
  'getting-started': {
    icon: 'document-edit',
  },
  'advertising-networks': {
    icon: 'gramophone',
  },
  finances: {
    icon: 'money',
  },
  'legal-entities-and-sole-proprietors': {
    icon: 'user',
  },
  labeling: {
    icon: 'tag',
  },
  'agency-dashboard': {
    icon: 'profile',
  },
}
